import React from 'react';
import { Tabs, Modal, Toast, Badge, Icon} from 'antd-mobile';
import {post} from '../../utils/request';

import api from './api';

import './index.less';

class InviteNewUsersDetail extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps: {},
            modalType: false,
            statictisData: '0',
            detailData: []
        };
    }

    // #/inviteNewUsers?app_stoken=xxxx&
    componentDidMount() {
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
                Toast.fail('请登录APP再进行操作',999);
                return;
            }
            
            this.setState({
                urlOps: ops
            },()=>{
                if(ops.app_stoken && ops.app_stoken != 'null'){
                    this.getInviteStatictis();
                    this.getSelectInviteList();
                }
            });
        }
    }

    getInviteStatictis(){
        const {urlOps} = this.state;
        post({
            url: api.inviteStatictis + '?app_stoken=' + urlOps.app_stoken,
            data: {}
        }).then((res) => {
            if(res.result === 'success'){
                this.setState({
                    statictisData: res.data
                })
            }else{
                Toast.info(res.msg,1);
            }
        }, (res)=>{
            Toast.info('获取统计数据失败',1);
        });
    }

    getSelectInviteList(){
        const {urlOps} = this.state;
        post({
            url: api.selectInviteList + '?app_stoken=' + urlOps.app_stoken,
            data: {
                activityCode: urlOps.activityCode,
                rewardStatus: 2
            }
        }).then((res) => {
            if(res.result === 'success'){
                let arr = [];
                let objs = {}
                res.data.map(item => {
                    let time = item.gmtCreate.slice(0,7)
                    if(objs[time]){
                        objs[time].push(item);
                    }else{
                        objs[time] = [item];
                    }
                })

                for(var key in objs){
                    arr.push({
                        time: key,
                        list: objs[key]
                    })
                }
                
                this.setState({
                    detailData: arr
                })
            }else{
                Toast.info(res.msg,1);
            }
        }, (res)=>{
            Toast.info('获取明细失败',1);
        });
    }

    render() {
        const {modalType, statictisData, detailData} = this.state
        const reg = /^(\d{3})\d{4}(\d{4})$/;

        const tabs = [
            { title: '奖励发放', },
            { title: '邀请记录' },
          ];
        return (
            <div className="InviteNewUsersDetailBox">
                <div className="totalAmountBox">
                    <div>
                        累计金额
                        <i onClick={()=>{
                            this.setState({
                                modalType: true
                            })
                        }}></i>
                    </div>
                    <p>{statictisData}</p>
                </div>

                <div> 
                <Tabs tabs={tabs}>
                    <div className="monthBox">
                        {
                            detailData.map((item,index)=>{
                                return (
                                    <div key={'riqi_'+index}>
                                        <h2>{item.time}</h2>
                                        <div>
                                            {
                                                item.list.map((obj,j)=>{
                                                    return (
                                                        <div key={'yaoqing_'+j} className="yaoqing-box">
                                                            <div className='yaoqing-left'>
                                                                <div className='phone'>被邀请人{obj.phoneNumber}充值</div>
                                                                <div className='grey'>{obj.gmtCreate}</div>
                                                            </div>
                                                            <div className='yaoqing-right'>
                                                                +{obj.inviteRewardAmount}
                                                                {/* .toFixed(2) */}
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="monthBox">
                        {
                            detailData.map((item,index)=>{
                                return (
                                    <div key={'riqi_'+index}>
                                        <h2>{item.time}</h2>
                                        <div>
                                            {
                                                item.list.map((obj,j)=>{
                                                    return (
                                                        <div key={'yaoqing_'+j} className="yaoqing-box">
                                                            <div className='yaoqing-left'>
                                                                <div className='phone'>邀请{obj.phoneNumber}</div>
                                                                <div className='grey'>{obj.gmtCreate}</div>
                                                            </div>
                                                            <div className='yaoqing-right'>
                                                                {/* +{obj.inviteRewardAmount} */}
                                                                {/* .toFixed(2) */}
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </Tabs>
                    
                    {/* <div>
                        <h2>12月</h2>
                        <div className="nullData">
                            暂无明细记录
                        </div>
                    </div> */}
                    {/* <div>
                        <h2>12月</h2>
                        <div>
                            <div>
                                <div>
                                    被邀请人133****1234充值
                                </div>
                                <div>
                                    +9.00
                                </div>
                            </div>
                            <div>
                                <div>
                                    被邀请人133****1234充值
                                </div>
                                <div>
                                    +9.00
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
                {modalType ? (
                <div className="modalBox">
                    <div>
                        <p>邀请成功发放券的总金额。</p>
                        <div onClick={()=>{
                            this.setState({
                                modalType: false,
                            })
                        }}>我知道了</div>
                    </div>
                </div>) : ''}
            </div>
        );
    }
};

export default InviteNewUsersDetail;


// WEBPACK FOOTER //
// ./src/inviteNewUsers/detail/index.js